enum YandexMetrikaEnums {
    id = "97873756"
}

export default YandexMetrikaEnums;